import axios from 'axios';
import { API_CONFIG, API_ENDPOINTS } from '../config/api.config';
import StorageUtil from '../utils/storage';
import { canHijackPath } from '../utils/authRealms';

let isRedirectingToLogin = false;

const expensesAxiosInstance = axios.create({
  baseURL: API_CONFIG.BASE_URL,
  headers: { 'Content-Type': 'application/json' },
});

expensesAxiosInstance.interceptors.request.use((config) => {
  const token = StorageUtil.getExpensesAccessToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

expensesAxiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const isLogout = error.config?.url?.includes(API_ENDPOINTS.EXPENSES.LOGOUT);
    if (error.response?.status === 401 && !isLogout) {
      StorageUtil.clearExpensesAuth();
      // Only a tab actually SHOWING the ops workspace may be sent to its
      // login. This same call can fire in a superadmin tab (three logins
      // share the browser) — that tab keeps its own session and its screen.
      if (!isRedirectingToLogin && canHijackPath('ops', window.location.pathname)) {
        isRedirectingToLogin = true;
        window.location.replace('/login?tab=expenses&reason=session_expired');
      }
    }
    return Promise.reject(error);
  }
);

export default expensesAxiosInstance;
